import onDOMContentLoaded from '../utils/on-dom-content-loaded';
import toggleAriaExpanded from '../utils/toggle-aria-expanded';
import { closeAllMenuLevels } from './nav-menu';

const toggleSearchAndMenuIcons = (searchDropdownIsOpen) => {
  const searchToggleMobileButton = document.querySelector('.js-search-toggle-mobile');
  const mobileNavToggle = document.querySelector('.js-toggle-mobile-nav');

  if (searchDropdownIsOpen) {
    searchToggleMobileButton.classList.toggle('hidden');
    mobileNavToggle.classList.toggle('hidden');
    searchToggleMobileButton.querySelector('.material-icons-round').innerHTML = 'close';
    searchToggleMobileButton.classList.toggle('hidden');
  } else {
    searchToggleMobileButton.classList.toggle('hidden');
    mobileNavToggle.classList.toggle('hidden');
    mobileNavToggle.querySelector('.material-icons-round').innerHTML = 'menu';
    searchToggleMobileButton.querySelector('.material-icons-round').innerHTML = 'search';
    searchToggleMobileButton.classList.toggle('hidden');
  }
};

export const toggleMobileSearchMenu = () => {
  const searchToggleMobileButton = document.querySelector('.js-search-toggle-mobile');
  const body = document.querySelector('body');
  const header = document.querySelector('header');
  const searchWrapper = document.querySelector('.js-search-mobile');

  toggleAriaExpanded(searchToggleMobileButton);

  if (searchWrapper.classList.contains('transition-in')) {
    searchWrapper.classList.remove('transition-in');
    searchWrapper.classList.add('transition-out');
    header.style.setProperty('--header-z-index', '510');
    body.style.overflow = 'auto';
    closeAllMenuLevels(0);
    setTimeout(() => {
      searchWrapper.classList.toggle('hidden');
    }, 400);
  } else {
    searchWrapper.classList.toggle('hidden');
    searchWrapper.classList.remove('transition-out');
    searchWrapper.classList.add('transition-in');
    header.style.setProperty('--header-z-index', '520');
    body.style.overflow = 'hidden';
  }

  toggleSearchAndMenuIcons(searchWrapper.classList.contains('transition-in'));
};

const mobileSearchDropdownToggleListener = () => {
  const searchToggleMobileButton = document.querySelector('.js-search-toggle-mobile');

  searchToggleMobileButton.addEventListener('click', () => {
    toggleMobileSearchMenu();
  });
};

const hideMenuButtonOnSearchPage = () => {
  const mobileNavToggle = document.querySelector('.js-search-toggle-mobile');
  if (window.location.pathname === '/search') {
    mobileNavToggle.classList.add('hidden');
  } else {
    mobileNavToggle.classList.remove('hidden');
  }
};

const initSearchInputHandler = () => {
  hideMenuButtonOnSearchPage();
  mobileSearchDropdownToggleListener();
};

onDOMContentLoaded().then(() => initSearchInputHandler());
